class Splitter {
    constructor(domElement, leftDomElement, rightDomElement, options) {
        this.domElement = domElement;
        this.leftDomElement = leftDomElement;
        this.rightDomElement = rightDomElement;
        this.storageKey = options.storageKey || null;

        this.lowerBound = (!!this.domElement.dataset.lbound) ?
            (this.domElement.dataset.lbound.toLowerCase() === 'initial' ?
                parseInt(window.getComputedStyle(this.domElement).left, 10) : (parseInt(
                    this.domElement.dataset.lbound, 10) || 0)) : 0;

        this.domElementLeft = 0;
        this.mouseDragDiffX = 0;

        this.documentMouseMoveEventHandler = null;
        this.documentMouseUpEventHandler = null;

        this.bindEvents();

        if (!!this.storageKey) {
            this.restoreState();
        }
    }

    bindEvents() {
        this.domElement.addEventListener('mousedown', this.onDomElementMouseDown.bind(this));
    }

    saveState(position) {
        if (!this.storageKey) {
            throw new Error('Unable to save state, no storage key set');
        }

        let states = {};
        try {
            states = JSON.parse(window['localStorage'].getItem(this.storageKey) || '{}');
        } catch (ex) {
        }

        states['position'] = position;
        window.localStorage.setItem(this.storageKey, JSON.stringify(states));
    }

    restoreState() {
        if (!this.storageKey) {
            throw new Error('Unable to restore state, no storage key set');
        }

        let states = {};
        try {
            states = JSON.parse(window['localStorage'].getItem(this.storageKey) || '{}');
        } catch (ex) {
        }

        const position = states['position'] || null;

        if (position !== null) {
            this.setPosition(position);
        }
    }

    setPosition(position) {
        this.domElement.style.left = position + 'px';

        // Set Right Position
        this.rightDomElement.style.width = 'auto';
        this.rightDomElement.style.left = (position + this.domElement.offsetWidth) + 'px';

        // Set Left Position
        const leftPadding = parseInt(window.getComputedStyle(this.leftDomElement).paddingLeft, 10);
        const newLeftDomElementRight = this.rightDomElement.getBoundingClientRect().width +
            this.domElement.offsetWidth + leftPadding;

        this.leftDomElement.style.width = 'auto';
        this.leftDomElement.style.right = newLeftDomElementRight + 'px';

        if (!!this.storageKey) {
            this.saveState(position);
        }
    }

    onDomElementMouseDown(e) {
        e.preventDefault();

        this.domElementLeft = this.domElement.offsetLeft;
        this.mouseDragDiffX = e.clientX - this.domElementLeft;

        this.documentMouseMoveEventHandler = this.onDocumentMouseMove.bind(this);
        this.documentMouseUpEventHandler = this.onDocumentMouseUp.bind(this);
        document.addEventListener('mousemove', this.documentMouseMoveEventHandler);
        document.addEventListener('mouseup', this.documentMouseUpEventHandler);
    }

    onDocumentMouseMove(e) {
        e.preventDefault();

        // Move the splitter
        const newPosition = e.clientX - this.mouseDragDiffX;
        if (newPosition <= this.lowerBound) {
            return;
        }

        this.setPosition(newPosition);
    }

    onDocumentMouseUp(e) {
        e.preventDefault();

        document.removeEventListener('mousemove', this.documentMouseMoveEventHandler);
        document.removeEventListener('mouseup', this.documentMouseUpEventHandler);
    }
}

export default Splitter;
